import { defaultLanguage } from '@stereoagency/constants';
import { createDocumentURL, findInKeyArray, sanityImageAsProps } from '@/utils';
import { researchPlatformsQuery } from './researchPlatformsQuery';
import { SimpleBlockContent } from '@/components/sanity/client';

export default function entryAsCardProps(
  group: (typeof researchPlatformsQuery)[1][number],
  lang: string,
) {
  const title = group.title
    ? findInKeyArray(group.title, [lang, defaultLanguage.id])
    : null;
  const description = group.introduction
    ? findInKeyArray(group.introduction, [lang, defaultLanguage.id])
    : null;
  const image = group.researchPlatformLeader?.image;

  if (!title?.value || !image || !group.slug?.current) {
    return null;
  }

  return {
    title: title.value,
    image: sanityImageAsProps(image),
    description: description?.value ? (
      <SimpleBlockContent value={description.value} />
    ) : null,
    action: {
      href: createDocumentURL(lang, 'researchPlatform', group.slug.current)
    },
  };
}
